// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"61":"transfer-users","922":"central-logs","945":"dashboard"}[chunkId] || chunkId) + "." + {"61":"1df5ea43","627":"bd7eb234","922":"84cbd149","945":"b267cdd4"}[chunkId] + ".css";
};